import { useState, useEffect, useCallback } from "react";
import { AuthState } from "@/types/auth";
import { authManager } from "@/lib/authManager";

export function useAuthState() {
  const [authState, setAuthState] = useState<AuthState>(authManager.getCurrentState());

  const retry = useCallback(() => {
    authManager.retry();
  }, []);

  const refetchProfile = useCallback(() => {
    // Profile refetching is handled by the auth manager
    return null;
  }, []);

  useEffect(() => {
    console.log("useAuthState: Setting up subscription to auth manager");
    
    // Subscribe to auth manager updates
    const unsubscribe = authManager.subscribe((newState) => {
      console.log("useAuthState: Received auth state update:", { 
        loading: newState.loading, 
        initialized: newState.initialized,
        hasUser: !!newState.user 
      });
      setAuthState(newState);
    });

    // Initialize auth manager if not already initialized
    authManager.initialize();

    return () => {
      console.log("useAuthState: Cleaning up subscription");
      unsubscribe();
    };
  }, []);

  return {
    authState,
    retry,
    refetchProfile,
    loadingStep: 'Initializing...',
    loadingProgress: authState.loading ? 50 : 100
  };
}